<template>
  <slot></slot>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.p-button {
  &:disabled {
    border: 1px solid $dark-grey2 !important;
    color: $dark-grey2 !important;
    background: white !important;
  }
}
.primary,
.p-button {
  background: $primary-color;
  color: black;
  border-radius: 4px;
  @include f-button1;
  &:enabled:hover {
    background: $grey;
  }
  &:enabled:focus {
    background: $dark-black;
  }
  .primary {
    border: 1px solid $black-grey;
  }

  &.p-button-text-back {
    color: $black-grey;
    border-radius: 0;
    &:enabled:hover {
      color: $grey;
    }
    &:enabled:focus {
      color: $dark-black;
    }
  }
  &.p-button-text {
    background: none !important;
    color: $black-grey;
    border-radius: 4px;
    &:enabled:hover {
      color: $grey;
    }
    &:enabled:focus {
      color: $dark-black;
    }
  }
}
button.p-button-textual-active {
  background: $black-grey !important;
  color: white !important;
}
.secondary {
  background: $secondary-color;
  color: white;
  border-radius: 4px;
  &:enabled:hover {
    background: $brand-color;
    color: $light-black;
  }
  &:enabled:focus {
    background: $brand-color;
    color: $light-black;
  }

  &.p-button-text {
    background: none !important;
    color: $grey;
    border-radius: 4px;
    &:enabled:hover {
      color: $grey;
    }
  
  }
}

.primary-color {
  border: 1px solid $primary-color;
  background: $primary-color !important;
  color: white !important;
  border-radius: 4px;
  @include f-button1;
  &:enabled:hover {
    box-shadow: 3px 3px 4px $grey;
    background: $primary-color;
    color: white;
  }
  &:enabled:focus {
    box-shadow: 3px 3px 4px $grey;
    background: $primary-color;
    color: white;
  }

  &.p-button-icon {
    color: $primary-color;
  }

  &.p-button-text {
    background: none !important;
    color: white;
    border-radius: 4px;
    &:enabled:hover {
      box-shadow: 3px 3px 4px $grey;
      color: white;
    }
    &:enabled:focus {
      color: white;
    }
  }
  height: 31px;
}

.primary-color-medium {
  @extend .primary-color;
  height: 31px;
}

.auth-button 
{
  @extend .primary-color;
  height: 30px !important;
  width: 30px !important;
  border-radius: 50% !important;
  color: white !important;
  min-width: 30px !important;
  background-color: $tertiary-color !important;
  border-color: $tertiary-color !important;
}


.ai_button
{
  @extend .primary-color;
  height: 30px !important;
  width: 30px !important;
  border-radius: 50% !important;
  color: white !important;
  min-width: 30px !important;
  background-color: $tertiary-color !important;
  border-color: $tertiary-color !important;
}

.primary-color-large {
  @extend .primary-color;
  @include f-banner-action;
  height: 41px;
  @media screen and (max-width: 768px) {
    height:35px
  }
}

.primary-color-small {
  @extend .primary-color;
  height: 30px;
  &.p-button {
    min-width: fit-content;
    padding: 10px;
  }
}

.secondary-color {
  border: 1px solid $secondary-color;
  background: $secondary-color;
  color: white;
  border-radius: 4px;
  @include f-button1;
  &:enabled:hover {
    box-shadow: 3px 3px 4px $grey;
    background: $secondary-color;
    color: white;
  }
  &:enabled:focus {
    box-shadow: 3px 3px 4px $grey;
    background: $secondary-color;
    color: white;
  }

  &.p-button-text {
    background: none !important;
 
    border-radius: 0;
    &:enabled:hover {
      box-shadow: 3px 3px 4px $grey;
      color: white;
    }
  
  }
  height: 31px;
}

.secondary-color-medium {
  @extend .secondary-color;
  height: 31px;
}

.secondary-color-large {
  @extend .secondary-color;
  @include f-banner-action;
  height: 41px;
  @media screen and (max-width: 768px) {
    height:35px
  }
}

.light-color {
  border: 1px solid $secondary-color;
  color: $secondary-color;
  border-radius: 4px;
  background: white;
  @include f-button1;
  &:enabled:hover {
    box-shadow: 3px 3px 4px $grey;
    background: white;
    border: 1px solid $secondary-color;
    color: $secondary-color;
  }
  &:enabled:focus {
    border: 1px solid $secondary-color;
    box-shadow: 3px 3px 4px $grey;
    background: white;
    color: $secondary-color;
  }

  &.p-button-text {
    background: none !important;
    color: $secondary-color;
    border-radius: 0;
    &:enabled:hover {
      box-shadow: 3px 3px 4px $grey;
      color: $secondary-color;
    }
    &:enabled:focus {
      color: $secondary-color;
    }
  }
  @media screen and (max-width: 800px) {
    
    &.p-button-label {
      font-size: 13px !important;
      line-height: 18px;
      @media screen and (max-width: 768px) {
        font-size: 13px !important;
        line-height: 14px !important;
      }
    }
  }
  height: 31px;
}

.light-color-large {
  @extend .light-color;
  @include f-banner-action;
  height: 41px;
  @media screen and (max-width: 768px) {
    height:35px
  }
}

.light-color2 {
  border: 1px solid $tertiary-color;
  color: $tertiary-color;
  border-radius: 4px;
  height: 31px;
  background: white;
  &:enabled:hover {
    box-shadow: 3px 3px 4px $grey;
    background: white;
    border: 1px solid $tertiary-color;
    color: $tertiary-color;
  }
  &:enabled:focus {
    border: 1px solid $tertiary-color;
    box-shadow: 3px 3px 4px $grey;
    background: white;
    color: $tertiary-color;
  }

  &:disabled {
    border: 1px solid $border-color;
    color: $border-color !important;
    background: white !important;
  }

  &.p-button-text {
    background: none !important;
    color: $tertiary-color;
    border-radius: 0;
    &:enabled:hover {
      box-shadow: 3px 3px 4px $grey;
      color: $tertiary-color;
    }
    &:enabled:focus {
      color: $tertiary-color;
    }
  }
  @include f-button1;
}

.light-color-medium {
  @extend .light-color;
  height: 31px;
}

.light-color2-medium {
  @extend .light-color2;
  height: 31px;
}

.light-color3 {
  border: 1px solid $primary-color;
  color: $primary-color;
  border-radius: 4px;
  background: white;
  &:enabled:hover {
    box-shadow: 3px 3px 4px $grey;
    background: white;
    border: 1px solid $primary-color;
    color: $primary-color;
  }
  &:enabled:focus {
    border: 1px solid $primary-color;
    box-shadow: 3px 3px 4px $grey;
    background: white;
    color: $primary-color;
  }

  &.p-button-text {
    background: none !important;
    color: $primary-color;
    border-radius: 0;
    &:enabled:hover {
      box-shadow: 3px 3px 4px $grey;
      color: $primary-color;
    }
    &:enabled:focus {
      color: $primary-color;
    }
  }
  @include f-button1;
}

.light-color3-medium {
  @extend .light-color3;
  height: 31px;
}

.signup {
  border: 1px solid $tertiary-color;
  color: white;
  border-radius: 4px;
  background: $tertiary-color;
  height: 31px;
  width: 150px;
  &:enabled:hover {
    box-shadow: 3px 3px 4px $grey;
    background: $tertiary-color;
    border: 1px solid $tertiary-color;
    color: white;
  }
  &:enabled:focus {
    border: 1px solid $tertiary-color;
    box-shadow: 3px 3px 4px $grey;
    background: $tertiary-color;
    color: white;
  }

  &.p-button-text {
    background: none !important;
    color: white;
    border-radius: 0;
    &:enabled:hover {
      box-shadow: 3px 3px 4px $grey;
      color: white;
    }
    &:enabled:focus {
      color: white;
    }
  }
}

.light {
  background: white !important;
  border: 1px solid $dark-grey2;
  color: $dark-grey2 !important;
  border-radius: 0;
  &:enabled:hover {
    color: $dark-grey2 !important;
    border: 1px solid $dark-grey2;
  }
  &:enabled:focus {
    color: $dark-grey2 !important;
    border: 1px solid $dark-grey2;
  }

  &.p-button-text {
    background: none !important;
    color: $dark-grey2;
    border-radius: 0;
    border: 0px !important;
    &:enabled:hover {
      color: $dark-grey2;
    }
    &:enabled:focus {
      color: $dark-grey2;
    }
  }
}

.light-large {
  @extend .light;
}

.light-auth {
  background: $primary-color !important;
  border: 1px solid none;
  color: white !important;
  border-radius: 0;
  &:enabled:hover {
    color: white !important;
    border: 1px solid $primary-color;
  }
  &:enabled:focus {
    color: white !important;
    border: 1px solid $primary-color;
  }

  &.p-button-text {
    background: none !important;
    color: white;
    border-radius: 0;
    border: 0px !important;
    &:enabled:hover {
      color: white;
    }
    &:enabled:focus {
      color: white;
    }
  }
  background-color: $primary-color !important;
  color: white !important;
}
.p-button-nav-active {
  border-bottom: 5px solid $primary-color !important;
}

.p-button-nav {
  white-space: nowrap;
  background: white !important;
  color: $brand-color !important;
  border-radius: 0 !important;
  min-width: fit-content !important;
  padding: 5px 5px;
  margin: 0 0.5vw 0.5vw;
  font-weight: bold;
  &:enabled:hover {
    color: $brand-color !important;
    border-bottom: 1px solid $primary-color !important;
  }
  &:enabled:focus {
    color: $brand-color !important;
    border-bottom: 5px solid $primary-color !important;
  }
  &:disabled {
    border-bottom: 0px solid $primary-color !important;
    background: none !important;
  }
}
</style>
